import React, { useContext } from 'react';
import { UserFlow } from '../../config/networkConfig';

import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function TokenRevokedScreen(): JSX.Element {
  const { flowSuccessful, networkName } = useContext(FlowConfigContext);

  const onConfirm = () => {
    flowSuccessful();
  };

  // If we are on the uniqueness network, show contextual info about it being revoked
  if (networkName === UserFlow.UNIQUENESS) {
    return (
      <MessagePanel
        title="screens.tokenRevoked.uniqueness_title"
        description="screens.tokenRevoked.uniqueness_description"
        buttonLabel="screens.tokenRevoked.buttonLabel"
        onConfirm={onConfirm}
        showSupportLink
      />
    );
  }

  return (
    <MessagePanel
      title="screens.tokenRevoked.title"
      description="screens.tokenRevoked.description"
      buttonLabel="screens.tokenRevoked.buttonLabel"
      onConfirm={onConfirm}
      showSupportLink
    />
  );
}
export default withRouteAnalytics(TokenRevokedScreen, Screens.TOKEN_REVOKED);
